import style from './galleryloader.module.scss'

export default function GalleryLoader() {

    return (
        <>
            <div className={style.gallerySpinner}></div>
            {/* <div className={`${style.galleryCardLoader} ${style.widthA}`} style={{ display: `${props.display ? 'flex' : 'none'}` }}></div> */}
            {/* <div className={`${style.galleryCardLoader} ${style.widthB}`} style={{ display: `${props.display ? 'flex' : 'none'}` }}></div> */}
            {/* <div className={`${style.galleryCardLoader} ${style.widthC}`} style={{ display: `${props.display ? 'flex' : 'none'}` }}></div> */}
            {/* <div className={`${style.galleryCardLoader} ${style.widthB}`} style={{ display: `${props.display ? 'flex' : 'none'}` }}></div> */}
            {/* <div className={`${style.galleryCardLoader} ${style.widthC}`} style={{ display: `${props.display ? 'flex' : 'none'}` }}></div> */}
            {/* <div className={`${style.galleryCardLoader} ${style.widthA}`} style={{ display: `${props.display ? 'flex' : 'none'}` }}></div> */}
        </>
    )
}
